// The Valet.red mark — two arches (red + grey) meeting over a gold pinprick.
// Pure CSS, no SVG.
//
// Sizes:
//   default — used in the sidebar header next to the wordmark (~h-20)
//   small   — compact rendering for tight headers
//   hero    — large centered mark for sign-in / MFA standalone pages.
//             Adds an extra red drop-shadow for the "premium glow" look on
//             the standalone auth flows.
type Props = { small?: boolean, size?: "default" | "small" | "hero" }

export function LogoMark({ small = false, size }: Props) {
  // Resolve the effective size. The legacy `small` prop wins when set so
  // existing call sites (sidebar) keep working unchanged.
  const effective: "default" | "small" | "hero" = small ? "small" : (size || "default")

  const root =
    effective === "small" ? "h-10 w-10"
    : effective === "hero" ? "h-28 w-28 [filter:drop-shadow(0_0_28px_rgba(225,6,19,0.55))_drop-shadow(0_0_60px_rgba(225,6,19,0.25))]"
    : "h-20 w-20"

  return (
    <div className={`relative ${root}`}>
      <div className="absolute bottom-[6%] left-[22%] h-[90%] w-[18%] origin-bottom -rotate-[24deg] rounded-t-full bg-gradient-to-t from-brand-redDeep via-brand-red to-[#FF5A61] shadow-redGlow" />
      <div className="absolute bottom-[6%] right-[22%] h-[90%] w-[18%] origin-bottom rotate-[24deg] rounded-t-full bg-gradient-to-t from-app-bg via-app-panel3 to-app-muted shadow-goldGlow" />
      <div className="absolute bottom-0 left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-vip-goldSoft shadow-[0_0_22px_8px_var(--vip-gold-mute)]" />
    </div>
  )
}
